// extracted by mini-css-extract-plugin
module.exports = {"page":"BlogPostsPage_page__51lz4","entryList":"BlogPostsPage_entryList__W7Q2Z"};